export const CENTRAL_SETTINGS_CACHE_PREFIX = 'centralSettingsCache:';
export const CENTRAL_SETTINGS_CACHE_EVENT = 'sales-26:central-settings-updated';

export const buildCentralSettingsCacheKey = (tenantId, companyId, scope = 'global') => {
    if (!tenantId || !companyId || !scope) return null;
    return `${CENTRAL_SETTINGS_CACHE_PREFIX}${tenantId}:${companyId}:${scope}`;
};

export const syncCentralSettingsCache = ({ tenantId, companyId, scope = 'global', data = null, version }) => {
    const cacheKey = buildCentralSettingsCacheKey(tenantId, companyId, scope);
    if (!cacheKey || typeof localStorage === 'undefined') return;

    const payload = {
        data,
        version: version ?? Date.now()
    };

    localStorage.setItem(cacheKey, JSON.stringify(payload));

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(CENTRAL_SETTINGS_CACHE_EVENT, {
            detail: {
                cacheKey,
                ...payload
            }
        }));
    }
};
